/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// It is not considering import as declaration , throwing lint error at import statement itself

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FeatureToggleDirective } from './directives/feature-toggle.directive';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [FeatureToggleDirective],
  exports: [FeatureToggleDirective],
})
export class FeatureToggleModule {
  constructor() {}
  public static forChild(): ModuleWithProviders<FeatureToggleModule> {
    return {
      ngModule: FeatureToggleModule,
    };
  }
}
